import React, { FC } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { Box, Typography, Skeleton } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { Tooltip } from 'transfix-ui'

export interface IInsightsCardTitleProps {
  isLoading?: boolean
  text?: string
  tooltip?: string
  spacing?: boolean
}

const useClasses = makeStyles(theme => ({
  textIcon: {
    display: 'flex',
    marginLeft: theme.spacing(1.25),
    alignItems: 'center',
  },
}))

export const InsightsCardTitle: FC<IInsightsCardTitleProps> = ({
  isLoading = true,
  spacing = false,
  text,
  tooltip,
}) => {
  const classes = useClasses()

  if (!text) {
    return null
  }

  return (
    <Typography variant='h3'>
      {isLoading ? (
        <Box mb={spacing ? 2 : 0}>
          <Skeleton width={144} animation='wave' />
        </Box>
      ) : (
        <Box display='flex' component='span' mb={spacing ? 2 : 0}>
          {text}
          {tooltip && (
            <Tooltip
              position='top'
              trigger={
                <span className={classes.textIcon}>
                  <InfoIcon size='medium' color='coolGray5' />
                </span>
              }>
              {tooltip}
            </Tooltip>
          )}
        </Box>
      )}
    </Typography>
  )
}
